export type StorefrontBannerLinkType = "product" | "category" | "custom";

export interface StorefrontBanner {
	id: string;
	name: string;
	imageUrl: string;
	linkType: StorefrontBannerLinkType;
	linkValue: string;
	startAt: string | null;
	endAt: string | null;
}

export function isStorefrontBanner(value: unknown): value is StorefrontBanner {
	if (!value || typeof value !== "object") return false;
	const banner = value as Record<string, unknown>;
	return (
		typeof banner.id === "string" &&
		typeof banner.name === "string" &&
		typeof banner.imageUrl === "string" &&
		(banner.linkType === "product" || banner.linkType === "category" || banner.linkType === "custom") &&
		typeof banner.linkValue === "string" &&
		(banner.startAt == null || typeof banner.startAt === "string") &&
		(banner.endAt == null || typeof banner.endAt === "string")
	);
}

export function hasValidStorefrontBanners(banners: StorefrontBanner[]): boolean {
	return banners.every(banner => {
		if (!banner.name.trim() || !banner.imageUrl.trim() || !banner.linkValue.trim()) return false;
		if (!/^(\/(?!\/)|https?:\/\/)/i.test(banner.imageUrl.trim())) return false;
		if (banner.startAt && !Number.isFinite(Date.parse(banner.startAt))) return false;
		if (banner.endAt && !Number.isFinite(Date.parse(banner.endAt))) return false;
		if (banner.startAt && banner.endAt && Date.parse(banner.endAt) < Date.parse(banner.startAt)) return false;
		if (banner.linkType === "custom" && !/^(\/(?!\/)|https?:\/\/)/i.test(banner.linkValue.trim())) return false;
		if (banner.linkType !== "custom" && (!/^\d+$/.test(banner.linkValue) || Number(banner.linkValue) < 1)) {
			return false;
		}
		return true;
	});
}
